module.exports = __webpack_public_path__ + "static/media/aquafury-2.9deade0f.jpg";